// import React, { useEffect, useState } from 'react';
// import { Navigate, useLocation } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { authenticateActions } from '../store/store';
// import NapidAuthAPI from '../api/napidAuthApi';
// import { persistStore } from 'redux-persist';
// import { store } from "../store/store.js";

// const PrivateRoute = ({ children, allowedRoles }) => {
//   const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
//   const location = useLocation();
//   const dispatch = useDispatch();
//   const accessToken = useSelector((state) => state.auth.accessToken);
//   const userRole = useSelector((state) => state.auth.userRole);
//   const [rehydrated, setRehydrated] = useState(false);


//   useEffect(() => {
//     // Here, we're listening for the rehydration to complete
//     const timeout = setTimeout(() => {
//       setRehydrated(true);
//     }, 300); // 300ms delay for state rehydration check
//     return () => clearTimeout(timeout);
//   }, []);
//   useEffect(() => {
//     const handleStorageChange = (e) => {
//       if (e.key === "logout") {
//         window.location.reload(); // Force re-evaluate auth state
//       }
//     };
//     window.addEventListener("storage", handleStorageChange);
//     return () => window.removeEventListener("storage", handleStorageChange);
//   }, []);

//   // If not rehydrated, prevent rendering until the Redux state is ready
//   if (!rehydrated) return null; // Or a loading spinner

//   // If not authenticated, trigger logout and redirect to login
//   if (!isAuthenticated) {
//     logoutApi();
//     return <Navigate to="/login" state={{ from: location }} replace />;
//   }
//   if (!rehydrated || !accessToken) return <Navigate to="/login" state={{ from: location }} replace />;

//   // If the user doesn't have the correct role, log them out and redirect
//   if (allowedRoles && !allowedRoles.includes(userRole)) {
//     logoutApi();
//     return <Navigate to="/login" state={{ from: location }} replace />;
//   }
//   if (isAuthenticated&&!rehydrated) {
//     logoutApi();
//     return <Navigate to="/login" state={{ from: location }} replace />;
//   }

//   return children;

//   // Function to log out the user and redirect
//   async function logoutApi() {
//     await NapidAuthAPI.logoutUser(accessToken); // API logout
//     localStorage.removeItem('refreshToken');
//     localStorage.setItem("logout", Date.now()); // Triggers storage event in other tabs
//     dispatch(authenticateActions.logout());
//   }
// };

// export default PrivateRoute;
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { authenticateActions } from '../store/store';
import { useEffect, useState, useRef } from 'react';
import NapidAuthAPI from '../api/napidAuthApi';
import { persistStore } from 'redux-persist';
import { store } from "../store/store.js";

const PrivateRoute = ({ children, allowedRoles }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const accessToken = useSelector((state) => state.auth.accessToken);
  const userRole = useSelector((state) => state.auth.userRole);
  const sessionId = useSelector((state) => state.auth.sessionId);
  const [rehydrated, setRehydrated] = useState(false);
  const navigate = useNavigate();
  const logoutRef = useRef(false);
  const currentSession = window.sessionStorage.getItem("currentSession");
  const latestSession = localStorage.getItem("sessionId");



  // Wait for rehydration
  useEffect(() => {
    const persistor = persistStore(store);
    if (persistor.getState().bootstrapped) {
      setRehydrated(true);
    } else {
      const unsubscribe = persistor.subscribe(() => {
        if (persistor.getState().bootstrapped) {
          setRehydrated(true);
          unsubscribe();
        }
      });
    }

    const fallback = setTimeout(() => setRehydrated(true), 1000);
    return () => clearTimeout(fallback);
  }, []);




  // useEffect(() => {
  //   const handleSessionChange = (e) => {
  //     if (e.key === "sessionId") {
  //       const currentSession = window.sessionStorage.getItem("currentSession");
  //       const latestSession = localStorage.getItem("sessionId");

  //       if (latestSession && latestSession !== currentSession) {
  //         sessionStorage.setItem("currentSession", latestSession);

  //         if (isAuthenticated) {
  //           setTimeout(() => {
  //             window.location.reload();
  //           }, 500);
  //         }
  //       }
  //     }
  //   };

  //   window.addEventListener("storage", handleSessionChange);
  //   return () => window.removeEventListener("storage", handleSessionChange);
  // }, [isAuthenticated]); // 👈 include isAuthenticated in deps


  if (!rehydrated) return null;

  if (!isAuthenticated || !accessToken) {
    logoutApi();
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  // if (rehydrated && currentSession && latestSession && currentSession !== latestSession) {
  //   localStorage.removeItem("isLoggedIn");
  //   return <Navigate to="/login" replace />;
  // }

  // if (allowedRoles && !allowedRoles.includes(userRole)) {
  //   logoutApi();
  //   return <Navigate to="/login" state={{ from: location }} replace />;
  // }

  return children;

  async function logoutApi() {
    console.log("logoutApi called private");
    await NapidAuthAPI.logoutUser(accessToken);
    localStorage.removeItem("refreshToken");
    localStorage.setItem("logout", Date.now()); // optional
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("sessionId");
    sessionStorage.removeItem("currentSession");
    dispatch(authenticateActions.logout());
  }
};

export default PrivateRoute;
